@if (emptyReason === null) {
  <div class="data-visualization-container">
    <app-data-visualization-filters
      class="padded-section"
      [sourceOptions]="sourceOptions"
      [sourceId]="currentFilters.sourceId"
      [startDate]="currentFilters.startDate"
      [endDate]="currentFilters.endDate"
      (filtersChanged)="onFiltersChanged($event)">
    </app-data-visualization-filters>

    <app-data-category-chips
      class="padded-section"
      [categories]="availableCategories"
      [selectedCategoryIds]="selectedCategoryIds"
      (selectionChanged)="onCategoriesChanged($event)">
    </app-data-category-chips>

    <!-- The chart component handles empty states internally -->
    <app-data-visualization-chart
      class="chart-section"
      [dataPoints]="chartData"
      [categories]="selectedCategories">
    </app-data-visualization-chart>
  </div>
}

@if (emptyReason === 'DATA_VISUALIZATION.NOT_ENOUGH_ENTRIES') {
  <p class="dv-empty-msg">{{ emptyReason | translate }}</p>
}

@if (emptyReason === 'DATA_VISUALIZATION.NOT_CONFIGURED') {
  <p class="dv-empty-msg">{{ emptyReason | translate }}</p>
}
